import type { AppTourStep, TourLaunchContext } from '@fordeer/app-tour'
import { defaultTourCatalogPort, type TourCatalogPort } from './tourPorts'
import type { InvoiceVirtualTourStepDefinition } from '../types/virtualTour.types'

export const resolveTourSteps = (
  stepDefinitions: InvoiceVirtualTourStepDefinition[],
  launchContext?: TourLaunchContext,
  catalog: TourCatalogPort = defaultTourCatalogPort,
): AppTourStep[] =>
  stepDefinitions.reduce<AppTourStep[]>((steps, step) => {
    const appStep = catalog.createStep({
      title: step.title,
      description: step.description,
      targetKey: step.targetKey,
      side: step.side,
      align: step.align,
      launchContext,
    })

    if (appStep != null) {
      steps.push(appStep)
    }

    return steps
  }, [])
